import { RootState } from "@app/redux/root-reducer";

export const selectContactUs = (store: RootState) =>
  store.contactUsReducer.contactUs;